import api from "./api";

export const rolesService = {
	getAll: async (
		page = 1,
		limit = 10,
		search = "",
		sortBy = "name",
		sortOrder = "asc",
	) => {
		const response = await api.get("/api/admin/roles", {
			params: { page, limit, search, sortBy, sortOrder },
		});
		return response.data;
	},

	getById: async (id) => {
		const response = await api.get(`/api/admin/roles/${id}`);
		return response.data;
	},

	create: async (data) => {
		const response = await api.post("/api/admin/roles", data);
		return response.data;
	},

	update: async (id, data) => {
		const response = await api.patch(`/api/admin/roles/${id}`, data);
		return response.data;
	},

	delete: async (id) => {
		const response = await api.delete(`/api/admin/roles/${id}`);
		return response.data;
	},
};
